import {
    CATEGORY_ALL,
    CATEGORY_GET,
    CATEGORY_PUT,
    CATEGORY_DEL,
    CATEGORY_POST,
  } from "../../actions/types";
  
  const initialState = {
    category: null,
    isLoading: false,
  };
  export default function (state = initialState, action) {
    switch (action.type) {
      case CATEGORY_ALL:
        return {
          arr: [...action.payload],
          isLoading: true,
        };
      case CATEGORY_GET:
        return {
          ...action.payload,
          isLoading: true,
        };
      case CATEGORY_POST:
        return action.payload;
      case CATEGORY_PUT:
        return action.payload;
      case CATEGORY_DEL:
        return { isLoading: true };
      default:
        return state;
    }
  }
  